module.exports = __webpack_public_path__ + "static/media/xls.338e47bb.svg";